import React, {useState} from 'react'
import {Button, Modal} from 'react-bootstrap'
import DatePicker from 'react-datepicker'

const SupportMessageFilter = ({showFilter, toggle}: any) => {
  const [selectedDate, setSelectedDate] = useState<any>(new Date())

  const handleChange = (date: any) => {
    setSelectedDate(date)
  }

  const handleFilterData = (e: any) => {
    e.preventDefault()
  }
  return (
    <Modal show={showFilter} className={`modal-md `}>
      <Modal.Header className='bg-primary-subtle'>
        <Modal.Title>Filter Option</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className='row' onSubmit={handleFilterData}>
          <div>
            <label className='form-label'>Month</label>
            <div className='w-full'>
              <DatePicker
                selected={selectedDate}
                onChange={handleChange}
                dateFormat='MM/yyyy'
                showMonthYearPicker
                showFullMonthYearPicker
                placeholderText='Select a month'
                className={`p-2 focus-none outline-none rounded-3 w-full border border-secondary `}
                style={{width: '100%'}}
              />
            </div>
          </div>

          <Modal.Footer className='mt-5'>
            <div className='mt-5 d-flex justify-content-end'>
              {/* <Button
                variant='secondary'
                size='sm'
                className='me-3'
                onClick={() => {
                  setSelectedDate(null)
                }}
              >
                Clear
              </Button> */}
              <Button variant='secondary' size='sm' className='me-3' onClick={() => toggle()}>
                Close
              </Button>
              <Button type='submit' variant='primary' size='sm'>
                Save
              </Button>
            </div>
          </Modal.Footer>
        </form>
      </Modal.Body>
    </Modal>
  )
}

export default SupportMessageFilter
